// Lazy-initialize the login portal: the full provider tree and LogIn form
// are only loaded when Auth.required() or Auth.login() first opens the dialog.
// This avoids adding ~60 KiB to Guide/Answers pages for users who never log in.
let loginPortalPromise = null;
window.ReactLoginPortal = {
   open: options => {
      if (!loginPortalPromise) {
         loginPortalPromise = import('Shared/LoginPortal').then(m => m.initializeLoginPortal());
      }
      loginPortalPromise.then(() => window.ReactLoginPortal.open(options));
   },
   close: () => {
      if (loginPortalPromise) {
         loginPortalPromise.then(() => window.ReactLoginPortal.close());
      }
   },
};
